
const Paragraph = ({ children, className = "", underline = false }) => {
  const hasCustomAlignment = className.includes('text-center') || className.includes('text-left') || className.includes('text-right');

  return (
    <p
      className={`text-black ${!hasCustomAlignment ? 'text-justify' : ''} font-medium ${className} ${
        underline ? "underline" : ""
      }`}
    >
      {children}
    </p>
  );
};

export default Paragraph;
